/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Error_Mfa_Reset_Not_PendingInputs */

const en_error_mfa_reset_not_pending = /** @type {(inputs: Error_Mfa_Reset_Not_PendingInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`This request was already approved or rejected.`)
};

/**
* | output |
* | --- |
* | "This request was already approved or rejected." |
*
* @param {Error_Mfa_Reset_Not_PendingInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const error_mfa_reset_not_pending = /** @type {((inputs?: Error_Mfa_Reset_Not_PendingInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Error_Mfa_Reset_Not_PendingInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_error_mfa_reset_not_pending(inputs)
});